import {ICustomPlayerModel, ICustomPlayerPreferences} from '../interfaces/customPlayer';
import { api } from './api';
import { firstValueFrom } from "rxjs";

export type ICustomPlayerFinderInput = {
  producerId: string;
  videoKey: string;
};

class CustomPlayerService {
  private readonly _DEFAULT_PLAYER_PREFERENCES: ICustomPlayerPreferences = {
    allowFullscreen: true,
    allowPlayPause: true,
    allowVolume: true,
    allowMuteUnmute: true,
    allowProgressBar: true,
    allowFastAdvance: true,
    allowFastBack: true,
    allowSubtitles: true,
    allowChangeQuality: true,
    allowPlaybackSpeed: true,
    allowPiP: true,
    allowActivateLoop: false,
    showLogotype: true,
    customPrimaryColor: '#FFBC00',
    customSecondaryColor: '#151B1E',
    customTextColor: '#FFFFFF'
  };

  public get defaultPlayerPreferences() {
    return this._DEFAULT_PLAYER_PREFERENCES;
  }

  async findCustomPlayer(input: ICustomPlayerFinderInput): Promise<ICustomPlayerModel | undefined> {
    const apiUrls = {
      defaultCustomPlayer: `/customized/producer/${input.producerId}`,
      specificVideoCustomPlayer: `/customized/producer/${input.producerId}/video/${input.videoKey}`
    };
    const specificVideoCustomPlayer = await firstValueFrom(api.get<ICustomPlayerModel>(apiUrls.specificVideoCustomPlayer));
    if (specificVideoCustomPlayer) {
      return specificVideoCustomPlayer;
    }
    const defaultCustomPlayer = await firstValueFrom(api.get<ICustomPlayerModel>(apiUrls.defaultCustomPlayer));
    const foundDefaultCustomPlayer = Boolean(defaultCustomPlayer);
    const findCustomPlayerResponse = foundDefaultCustomPlayer ? defaultCustomPlayer : undefined;
    return findCustomPlayerResponse;
  }
}

export const customPlayerService = new CustomPlayerService();
